import { useContext } from 'react';
import DataContext from '../Contexts/DataContext';

export default function useClinicConfig() {
  const { clinicConfig } = useContext(DataContext);
  return clinicConfig;
}
